import axios from 'axios';
import { get } from 'lodash';

import BackendConnector from './backendConnector';

const REQUEST_CANCEL_MSG = 'CANCEL';

class TalentScoreHttpService {
    currentRequest = null;

    getTotalTalentPoolAmount(data) {
        if (this.currentRequest && this.currentRequest.cancel) {
            this.currentRequest.cancel(REQUEST_CANCEL_MSG);
        }

        this.currentRequest = axios.CancelToken.source();

        return BackendConnector.post(
            'talentScore/getTotalTalentPoolAmount',
            data,
            { cancelToken: this.currentRequest.token, handleAuthError: false },
        )
            .then((response) => {
                if (!get(response, 'isCancelled')) {
                    this.currentRequest = null;
                }
                return response;
            })
            .catch(() => {
                this.currentRequest = null;
            });
    }
}

export default new TalentScoreHttpService();
